import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Layout } from "../components/Layout";
import { DogCard } from "../components/DogCard";
import api from "../lib/api";

export default function BreedDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/breeds/${slug}`).then((r) => setB(r.data)); }, [slug]);
  if (!b) return <Layout><div className="max-w-[1400px] mx-auto px-5 py-32 text-eon-muted">Loading...</div></Layout>;

  const facts = [["Origin", b.origin], ["Group", b.group], ["Size", b.size], ["Lifespan", b.lifespan], ["Energy", b.energy], ["Trainability", b.trainability]];
  const sections = [["Temperament", b.temperament], ["Care", b.care], ["Exercise", b.exercise], ["History", b.history], ["Ownership Fit", b.ownership_fit]];

  return (
    <Layout>
      <section className="relative h-[46vh] overflow-hidden">
        <img src={b.image} alt={b.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-eon-bg to-eon-bg/30" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-8 h-full flex flex-col justify-end pb-10">
          <Link to="/breeds" className="flex items-center gap-2 text-sm text-eon-text/70 hover:text-eon-gold mb-4 transition-colors"><ArrowLeft size={16} /> Breed Library</Link>
          <div className="eon-label mb-2">{b.group}</div>
          <h1 className="eon-heading text-5xl lg:text-7xl uppercase">{b.name}</h1>
        </div>
      </section>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-12 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          {sections.map(([t, body]) => (
            <div key={t}><div className="eon-label mb-3">{t}</div><p className="text-lg text-eon-text/80 leading-relaxed">{body}</p></div>
          ))}
        </div>
        <aside>
          <div className="sticky top-24 eon-card p-6">
            <div className="eon-label mb-4">Quick Facts</div>
            <div className="space-y-3">{facts.map(([k, v]) => (<div key={k} className="flex justify-between border-b border-eon-border pb-2"><span className="text-sm text-eon-muted">{k}</span><span className="text-sm text-eon-text text-right">{v}</span></div>))}</div>
          </div>
        </aside>
      </div>
      {b.related_dogs?.length > 0 && (
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 pb-16">
          <h2 className="eon-heading text-3xl uppercase mb-8">Available {b.name}s</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">{b.related_dogs.map((d, i) => <DogCard key={d.id} dog={d} index={i} />)}</div>
        </div>
      )}
    </Layout>
  );
}
